import React from 'react';
import styled, { keyframes } from 'styled-components';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ErrorContainer = styled.div`
  text-align: center;
  animation: ${fadeIn} 2s ease-in-out;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: Arial, sans-serif;
  padding: 20px; 
`;

const ErrorTitle = styled.h1`
  font-size: 5rem; 
  color: #343a40;
  margin-bottom: 10px; 
`;

const ErrorMessage = styled.p`
  font-size: 1.5rem; 
  color: #6c757d;
  text-align: center;
`;

function Error() {
  const location = useLocation();
  const from = location.state?.from || "/";

  return (
    <ErrorContainer>
      <div>
        <ErrorTitle>Sem permissão</ErrorTitle>
        <br />
        <ErrorMessage>Você não tem permissão para acessar a página: {from}</ErrorMessage>
        <br></br>
        <Link to="/home">
          <button className='error_button'>
            Clique aqui para voltar ao Inicio
          </button>
        </Link>
      </div>
    </ErrorContainer>
  );
}

export default Error;
